import React, { FC, useId } from 'react';
import { useField } from 'formik';
import { IFormFieldProps } from '@components/Form/types';
import { Status } from '@components/Status';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { Field } from '../Field';
import { Input } from '../Input';

export const InputField: FC<IFormFieldProps> = (props) => {
  const { dictionary } = useLanguageContext();

  const {
    id = '',
    showLabel = true,
    label = '',
    showHint = true,
    showError,
    hint = '',
    status,
    isVerified,
    showRequired = false,
    required = true,
    fieldControls,
  } = props;

  const uniqId = useId();

  const fieldId = id || uniqId;

  const [field, meta] = useField(props);

  const statusLabel = isVerified ? dictionary.statuses.verified : dictionary.statuses.notVerified;

  const statusVariant = isVerified ? 'success' : 'warning';

  return (
    <Field
      id={fieldId}
      showLabel={showLabel}
      label={label}
      showError={showError !== undefined ? showError : meta.touched}
      error={meta.error}
      showHint={showHint}
      hint={hint}
      showRequired={showRequired}
      isRequired={required}
      fieldControls={fieldControls}
      status={status && <Status text={statusLabel} variant={statusVariant} />}
    >
      <div className="field-control">
        <Input {...field} {...props} hasError={meta.touched && !!meta.error} />
      </div>
    </Field>
  );
};
